/**
 * Handles tab functionality for Loyalty Favorites LP
 *
 * @module loyaltyFavorites
 */

import $ from "jquery";

$(() => {
  // Should only run if we're on a loyalty favorites LP
  if ($('.loyalty-favorites').length) {
    const $tabs = $('.loyalty-favorites__tabs');
    const $content = $('#loyalty-favorites-content');
    const $tabAlert = $('#loyalty-tab-alert');
    const $products = $content.find('.loyalty-favorites__products');
    const ACTIVE_CLASS = 'loyalty-favorites__tab--active';

    $tabs.on('click', '[data-tab]', function() {
      let tab = $(this).data('tab');
      const $clickedTab = $(this).closest('.loyalty-favorites__tab');

      if ($clickedTab.hasClass(ACTIVE_CLASS)) {
        return;
      }

      $tabs.find('.loyalty-favorites__tab').removeClass(ACTIVE_CLASS).attr('aria-selected', 'false');
      $clickedTab.addClass(ACTIVE_CLASS).attr('aria-selected', 'true');

      $.ajax({
        url: `ajax/${tab}.jsp`,
        dataType: 'html',
        success: function(html) {
          $products.html(html);
          waitForFirstRowImages();
          $products.find('.js-lazy-image').lazy({
            effect: 'fadeIn',
            effectTime: 300,
          });
          if (tab === 'vip') {
            tab = tab.toUpperCase();
          }
          $tabAlert.text(`${tab} tier product listing loaded`);
        },
        error: function(err) {
          console.error("Error loading Loyalty Favorites HTML content", err);
        },
      });
    });

    function waitForFirstRowImages() {
      const $images = $('#loyalty-favorites-content .n-block-grid--2 li img');
      if ($images.length <= 4) return;
      // Select the first four images (2 rows of 2)
      const $firstRowImages = $('#loyalty-favorites-content .n-block-grid--2 li:lt(4) img');
      let imagesLoaded = 0;

      $firstRowImages.each(function() {
        if (this.complete) { // Check if image is already cached
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            addHeartEvent();
          }
        } else {
          $(this).on('load', function() {
            imagesLoaded++;
            if (imagesLoaded === $firstRowImages.length) {
              addHeartEvent();
            }
          });
        }

        $(this).on('error', function() {
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            addHeartEvent();
          }
        });
      });

      // Handle case where there are no images in the first row
      if ($firstRowImages.length === 0) {
        addHeartEvent();
      }
    }

    function addHeartEvent() {
      if (typeof window.bindHeartEvent === 'function') {
        window.bindHeartEvent($('#loyalty-favorites-content .js-favorite-button'));
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/loyalty-favorites.js